<template>
    <v-layout row wrap>
        <v-flex xs10 offset-xs1 lg8 offset-lg2>
            <v-form ref="form" @submit.prevent="submit">
                <v-card class="pa-3" v-if="!loading">
                    <v-card-text>
                        <div class="subheading">{{ $t('label.basicInfo') }}</div>
                        <v-layout row>
                            <v-flex xs3 lg2>
                                <label class="form-label">{{ $t('label.acronym') }}</label>
                            </v-flex>
                            <v-flex xs7 lg5>
                                <v-text-field :disabled="disabled" v-model="form.acronym" :maxlength="constants.LENGTH_SYSTEM_ACRONYM"></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs3 lg2>
                                <label class="form-label">{{ $t('label.name') }}</label>
                            </v-flex>
                            <v-flex xs7 lg5>
                                <v-text-field :disabled="disabled" v-model="form.name" :rules="validation.text"></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs3 lg2>
                                <label class="form-label">{{ $t('label.office') }}*</label>
                            </v-flex>
                            <v-flex xs7 lg6>
                                <v-select autocomplete :disabled="disabled || defaultOffice" v-bind:items="offices" v-model="form.office.id" :rules="validation.required" :no-data-text="$t('message.warning.noData')"></v-select>
                            </v-flex>
                        </v-layout>

                        <v-layout row>
                            <v-flex xs3 lg2>
                                <label class="form-label">{{ $t('label.isOutsourced') }}?</label>
                            </v-flex>
                            <v-flex xs9 lg10>
                                <v-checkbox :disabled="disabled" v-model="form.isOutsourced" color="primary"></v-checkbox>
                            </v-flex>
                        </v-layout>

                        <v-layout row>
                            <v-flex xs3 lg2>
                                <label class="form-label">{{ $t('label.active') }}?</label>
                            </v-flex>
                            <v-flex xs9 lg10>
                                <v-checkbox :disabled="disabled" v-model="form.isActive" color="primary"></v-checkbox>
                            </v-flex>
                        </v-layout>
                    </v-card-text>

                    <v-card-actions v-if="!disabled">
                        <v-btn :loading="saving" @click="save" color="primary">{{ $t('label.save') }}</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>

                </v-card>
                <v-card v-else>
                    <app-card-loader></app-card-loader>
                </v-card>
            </v-form>
        </v-flex>
    </v-layout>
</template>

<script>
import constants from '@/helpers/constants';
import utilities from '@/helpers/utilities';
import validation from '@/helpers/validation';
import Area from '@/helpers/entities/Area';

import CardLoader from '@/components/shared/CardLoader';

export default {
    data() {
        return {
            constants,
            validation,
            valid: true,
            saving: false,
            loading: true,
            defaultOffice: false,

            form: Area.build(),
            offices: this.$store.getters.officesValueText,
        };
    },
    computed: {
        isAdmin() {
            return this.$store.getters.isAdmin;
        },
        isRoot() {
            return this.$store.getters.profile.isRoot;
        },
        disabled() {
            return !(this.isAdmin || this.isRoot);
        },
    },

    components: {
        appCardLoader: CardLoader,
    },

    watch: {
        $route: 'fetch',
    },

    created() {
        this.fetch();
    },

    methods: {
        async fetch() {
            this.loading = true;

            if (!utilities.isEmptyOrZero(this.$route.params.id)) {
                await this.$store.dispatch('fetchArea', this.$route.params.id);
                this.form = Area.toForm(this.$store.getters.area);
            }

            this.loading = false;
        },

        async save() {
            if (!this.$refs.form.validate()) return;

            this.saving = true;
            await this.$store.dispatch('saveOrUpdateArea', Area.toPayload(this.form));
            this.$router.push({ name: 'areaIndex' });
        },
        hasOffice() {
            if (this.$store.getters.profile.office > 0) {
                this.form.officeId = this.$store.getters.profile.office;
                this.defaultOffice = true;
            }
        },
    },
};
</script>




// WEBPACK FOOTER //
// src/components/areas/Edit.vue